import { useState, useEffect } from "react";
import ChatWidget from "../components/kits/chat_widget/ChatWidget";

export default function ChatWidgetPage() {
  return (
    // <div className="col-6 m-auto" style={{ height: "100vh" }}>
    <ChatWidget page={true} />
    // </div>
  );
}
